import {
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography
} from "@mui/material";
import { AccountCircle } from "@mui/icons-material";

import { Dialog } from "components/Dialog";
import { IUserRow } from "interfaces/user";

export interface ToggleUserDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  user: IUserRow;
}

export function ToggleUserDialog({
  isOpen,
  onClose,
  onConfirm,
  user
}: ToggleUserDialogProps): JSX.Element {
  const ACTION_NAME = user?.isActive ? "Deactivate" : "Activate";

  return (
    <Dialog
      dialogId="dialog-toggle-user"
      title={`${ACTION_NAME} User`}
      open={isOpen}
      fullWidth={true}
      onClose={onClose}
      data-qa="User-Dialog-Toggle-User"
      confirmButton={
        <Button
          data-qa="Users-Button-Toggle-User"
          variant="contained"
          color="secondary"
          onClick={onConfirm}
        >
          {ACTION_NAME}
        </Button>
      }
    >
      <Typography sx={{ mb: 1 }}>
        Are you sure you want to {ACTION_NAME.toLowerCase()} this user?
      </Typography>

      <List sx={{ p: 0 }}>
        <ListItem sx={{ py: 0, gap: 1 }}>
          <ListItemIcon sx={{ minWidth: "unset" }}>
            <AccountCircle />
          </ListItemIcon>
          <ListItemText>
            {`${user?.firstName} ${user?.lastName} <${user?.email}>`}
          </ListItemText>
        </ListItem>
      </List>
    </Dialog>
  );
}
